import { render, staticRenderFns } from "./uploadPic.vue?vue&type=template&id=090878e8&scoped=true&"
import script from "./uploadPic.vue?vue&type=script&lang=js&"
export * from "./uploadPic.vue?vue&type=script&lang=js&"
import style0 from "./uploadPic.vue?vue&type=style&index=0&id=090878e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090878e8",
  null
  
)

export default component.exports